import React from 'react';
import SEO from "../common/SEO";
import {FiFacebook, FiInstagram } from "react-icons/fi";
import Layout from '../common/Layout';
import { Link } from 'react-router-dom';
import Separator from '../separator/Separator';
import Amission from '../data/about/mission.json'
import Mission from '../elements/about/Mission';
import SectionTitle from '../elements/sectionTitle/SectionTitle';
import { GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME } from '../data/GraphHooks/useChapterMembers';
import Teamm from '../elements/team/teamm';
import { useQuery } from '@apollo/client';

const TMission = Amission[3];
const RasChapt = () => {
    const roleDispatching = useQuery(GET_ROLE_DISPATCHING_BY_UNIT_SHORTNAME, {variables:{unitShortname: 'RAS SBC', }, })
    return (
        <>
            <SEO title="Ras Chapter IEEE ISSAT Sousse || Ras Chapter IEEE ISSATSo" />
            <main className="page-wrapper">
                <Layout>

                {/* Start Slider Area  */}
                <div className="slider-style-6 shape-left height-750 ">
                    <div className="container">
                        <div className="row row--30 align-items-center">
                            <div className="order-2 order-lg-1 col-lg-6 mt_md--50 mt_sm--50 mt_lg--30">
                                <div className="inner text-left">
                                    <h1 className="title color-white">RAS Chapter</h1>
                                    <p className="description color-white">Robotics and Automation Society.</p>
                                    <div className="button-group mt--30 mt_sm--20">
                                    <Link target="_blank" to={{pathname: "https://www.facebook.com/IEEE.RAS.ISSATSO.SBC"}}><FiFacebook /></Link>
                                    <Link target="_blank" to={{pathname: "https://www.instagram.com/ieee.ras.issatso.sbc/"}}><FiInstagram /></Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6 order-1 order-lg-2">
                                <div className="thumbnail">
                                    <img src="./images/banner/rasbanner.png" alt="Banner Images" />
                                </div>
                            </div>
                            <div className="shape-image">
                                <img src="./images/banner/white-shape.svg" alt="Banner Images" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}
                <Separator />
                <div className="rwt-team-area rn-section-gap">
                        <div className="wrapper plr--200 plr_sm--15">
                            <div className="row mb--20">
                                <div className="col-lg-12">
                                        <SectionTitle
                                            textAlign = "text-center"
                                            radiusRounded = ""
                                            subtitle = "Our RAS Team"
                                            title = "Robotics and Automation Society Board"
                                            description = ""
                                        />
                                </div>
                            </div>
                            {roleDispatching.data && (
                                <Teamm column="col-lg-4 col-md-6 col-12" teamStyle="team-style-default style-two" data={roleDispatching.data.rd} />
                            )}
                        </div>
                    </div>
                <div className="rwt-timeline-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                        <div className="col-lg-12 offset-lg-12">
                            <div className="col-lg-12 ">
                                <Separator />
                            </div>
                                <Mission 
                                mainTitle={TMission.mainTitle} 
                                typedTitle={TMission.typedTitle}
                                Paragraphe={TMission.Paragraphe}
                                Paragraphe2={TMission.Paragraphe2}
                                directlink={TMission.directlink}
                                positionAccord={3}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                </Layout>
            </main>
        </>
    )
}

export default RasChapt;
